const config = require('../../config')

export default {
    // 配置显示在浏览器标签的title
    title: '一个正经的程序员 | 散淡样子 | 刘欣 | 个人心路历程',
    // 域名
    // domain: '',
    // 基本URL：服务器API，打包发布
    baseUrl: 'https://api.liuxin.online/api'
    // 基本URL：本地API，本地开发
    // baseUrl: 'http://' + config.dev.host + ':' +  config.dev.port + '/dev/api'
}


// WEBPACK FOOTER //
// ./src/config/index.js